<mat-form-field>
  @if(label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <input matInput (keyup)="onKeyUpEvent($event)">
  @if(matIcon()) {
  <span matPrefix>
    <mat-icon matPrefix>{{ matIcon() }}</mat-icon>
  </span>
  }
  @if (showHint() && hint().length > 0) {
  <mat-hint class="hint">{{ hint() }}</mat-hint>
  }
</mat-form-field>